import React, { Suspense, ReactElement } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import LazyLoader from './components/LazyLoader';
import { UserContext } from './core/context/UserContext';
import DeploymentCompare from './components/deployments/compare/DeploymentCompare';
import VpcPeers from './components/vpc/VpcPeers';
import Account from './components/account/Account';
import Projects from './components/projects/Projects';
import DataStore from './components/projects/dataStores/DataStore';
import AddService from './components/deployments/services/AddService';
import AdminTables from './components/admin/AdminTables';
import Error404Page from './components/errors/Error404Page';

/**
 * Routes definitions
 */
function AppRoute(): ReactElement {
    return (
        <Suspense fallback={<LazyLoader />}>
            <UserContext.Consumer>
                {({ user: userConsumer }) => (
                    <>
                        <Switch>
                            <Route path="/" exact>
                                {/* <Home /> */}
                                {/* @TODO: Remove the redirection */}
                                <Redirect to="/projects/default/data-stores" />
                            </Route>

                            <Route path="/onboarding">
                                <Redirect to="/" />
                            </Route>

                            <Route path="/admin" exact>
                                <AdminTables />
                            </Route>
                            <Route path="/account" exact>
                                <Account />
                            </Route>

                            <Route
                                path="/projects/:projectUuid/:activeTab"
                                exact
                            >
                                <Projects />
                            </Route>

                            <Route
                                path="/projects/:projectUuid/vpcs/:vpcUuid/peerings"
                                exact
                            >
                                <VpcPeers />
                            </Route>

                            <Route
                                path="/projects/:projectUuid/vpcs/:vpcUuid/peerings/add"
                                exact
                            >
                                <VpcPeers />
                            </Route>

                            <Route
                                path="/projects/:projectUuid/services/new/:service"
                                exact
                            >
                                <AddService user={userConsumer} />
                            </Route>

                            <Route
                                path="/projects/:projectUuid/data-stores/add"
                                exact
                            >
                                <Suspense fallback={<LazyLoader />}>
                                    <AddService user={userConsumer} />
                                </Suspense>
                            </Route>

                            <Route
                                path="/projects/:projectUuid/data-stores/:dataStoreUuid/:activeTab/:tab"
                                exact
                            >
                                <DataStore />
                            </Route>

                            <Route
                                path="/projects/:projectUuid/data-stores/:dataStoreUuid/:activeTab"
                                exact
                            >
                                <DataStore />
                            </Route>

                            <Route
                                path="/projects/:projectUuid/data-stores/:dataStoreUuid/compare/:tab"
                                exact
                            >
                                <Suspense fallback={<LazyLoader />}>
                                    <DeploymentCompare />
                                </Suspense>
                            </Route>

                            {/* No match */}
                            <Route exact path="*">
                                <Error404Page />
                            </Route>
                        </Switch>
                    </>
                )}
            </UserContext.Consumer>
        </Suspense>
    );
}

export default AppRoute;
